import { Commit } from 'vuex';
import * as Types from './types';
import * as API from './api';
import { ITaskState } from './interface';
import { Toast } from 'vant';

const state: ITaskState = {
    loading: false,
    infos: [],
    status: 0,
    loadingRecieve: false,
    loadingReject: false,
};

const actions = {
    async [Types.CENTER_GET_TASK](context: { commit: Commit; state: ITaskState }, params: any) {
        let result: any = {};
        context.commit(Types.CENTER_GET_TASK, { loading: true, result });
        result = await API.CenterGetTask([params]);
        context.commit(Types.CENTER_GET_TASK, { loading: false, result });
    },
    async [Types.CENTER_RECEIVE_TASK](context: { commit: Commit; state: ITaskState }, params: any) {
        Toast.loading({
            duration: 0,
            message: '',
            forbidClick: true,
        });
        context.commit(Types.CENTER_RECEIVE_TASK, { loading: true });
        const result = await API.CenterReceiveTask([params]);
        context.commit(Types.CENTER_RECEIVE_TASK, { loading: false, result });
    },
    async [Types.CENTER_REJECT_TASK](context: { commit: Commit; state: ITaskState }, params: any) {
        Toast.loading({
            duration: 0,
            message: '',
            forbidClick: true,
        });
        context.commit(Types.CENTER_REJECT_TASK, { loading: true });
        const result = await API.CenterRejectTask([params]);
        context.commit(Types.CENTER_REJECT_TASK, { loading: false, result });
    },
};

const mutations = {
    [Types.CENTER_GET_TASK](state: ITaskState, payload: any) {
        state.loading = payload.loading;
        const result = payload.result;
        if (payload.loading === false) {
            state.status = result.status;
            if (result.status === 200) {
                state.infos = result.data;
            } else {
                Toast.fail(result.message);
            }
        }
    },
    [Types.CENTER_RECEIVE_TASK](state: ITaskState, payload: any) {
        state.loadingRecieve = payload.loading;
        if (!payload.loading) {
            Toast.clear();
            Toast.success('同意成功');
        }
    },
    [Types.CENTER_REJECT_TASK](state: ITaskState, payload: any) {
        state.loadingReject = payload.loading;
        if (!payload.loading) {
            Toast.clear();
            Toast.success('拒绝成功');
        }
    },
};

export default { namespaced: true, state, actions, mutations };
